import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { SupportContactDetails } from '../../interfaces/knowledge-base/support-contact-details';

@Injectable()

export class SupportContactDetailsService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  get(): Observable<SupportContactDetails | boolean> {
    return new Observable<SupportContactDetails | boolean>((o: Subscriber<SupportContactDetails | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.knowledge-base.support-contact-details'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<SupportContactDetails>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  update(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('configuration.knowledge-base.support-contact-details'), formData);
  }
}
